module.exports = __webpack_public_path__ + "img/lotto.89b9fbf2.png";